<template>
  <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4.99998 5.8375C4.81665 5.8375 4.64998 5.77084 4.51665 5.63751L0.349976 1.30418C0.23331 1.17084 0.166647 1.00417 0.166647 0.837501C0.166647 0.654168 0.233315 0.487497 0.366649 0.354164C0.633316 0.104164 1.04998 0.10416 1.31665 0.370826L4.99998 4.20416L8.68332 0.370827C8.93332 0.10416 9.36665 0.104164 9.63331 0.354164C9.89998 0.604164 9.89998 1.03751 9.64998 1.30418L5.48331 5.63751C5.34998 5.77084 5.18331 5.8375 4.99998 5.8375Z" :fill="fill"/>
  </svg>
</template>

<script>
  export default {
    name: 'chevronIcon',
    props: {
      fill: {
        type: String,
        default: '#00527F'
      }
    }
  }
</script>
